export default "__VITE_ASSET__4dc36b50__"